import { render } from "micromustache";
export function interpolate(template, scope = {}) {
  return render(template, scope);
}
